import { ToggleButton } from 'shared/mui/ToggleButton/ToggleButton';
import { ToggleButtonGroup } from 'shared/mui/ToggleButtonGroup/ToggleButtonGroup';

type Props = {
  isBulk: boolean;
  onChange: (isBulk: boolean) => void;
};

export const GatewaysCreateModeToggle: React.FC<Props> = ({ isBulk, onChange }) => (
  <ToggleButtonGroup
    color="primary"
    exclusive
    onChange={(_, value) => {
      if (value !== null) {
        onChange(value);
      }
    }}
    size="small"
    sx={{ mt: 3 }}
    value={isBulk}
  >
    <ToggleButton value={false}>Один шлюз</ToggleButton>
    <ToggleButton value={true}>Два шлюза (FTD/TTD)</ToggleButton>
  </ToggleButtonGroup>
);
